// extracted by mini-css-extract-plugin
export default {"info-button":"IconButton_info-button__H7hSK"};